import { realApi } from './api';

// Lista de clubes (id, nombre). Solo ADMIN/COMITE.
export const getClubes = () => realApi.get('/clubes').then((r) => r.datos);

// Plantilla de clubes de una temporada (jugador_club), con los equipos de
// esa temporada en los que sigue de alta cada jugador. Solo ADMIN/COMITE.
export const getClubJugadores = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/club-jugadores`).then((r) => r.datos);

// Estado final deseado: [{ jugadorId, clubId }]. El backend calcula el diff
// y aplica las reglas por estado (INICIADA solo admite altas; FINALIZADA
// nada); si no las cumple responde 409 con el mensaje ya en castellano.
export const guardarClubJugadores = (temporadaId, jugadores) =>
  realApi
    .put(`/temporadas/${encodeURIComponent(temporadaId)}/club-jugadores`, { jugadores })
    .then((r) => r.datos);
